export function createHttpBody<T extends object>(body: T): T {
  const result = { ...body };

  for (const key in result) {
    const value = result[key];

    if (Array.isArray(value) && value.length === 0 || value === '' || value == null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete result[key];
    }
  }

  return result;
}
